import React from 'react';
import { withRouter, useHistory } from 'react-router-dom';

import {
    Box, Grid, 
    Button,
    TextField,
    FormHelperText, LinearProgress,GridListTile, GridListTileBar,
    withWidth, isWidthUp,GridList
} from '@material-ui/core';
import { useStyles } from "../styles";
import * as Icons from "../iconComponents";
import { useFormContext, Controller } from "react-hook-form";
import { IAppPropsWithRoute } from '../../../common/types';
import { KeyboardDatePicker,  MuiPickersUtilsProvider, TimePickerView } from '@material-ui/pickers';
import { format, getDate } from "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import { time } from 'console';
import { useState } from 'react';
import IndexedDb from '../IndexedDb';
import api from "../../../store/api";
import { v4 as uuidv4 } from 'uuid';
import PcrSlice, { setpcrstate } from '../../../store/modules/PcrSlice';
import { useDispatch } from 'react-redux';
import { useSelector } from "react-redux";
import { pcrstate } from "../../../store/modules/PcrSlice";
interface PcrWidgetProps extends IAppPropsWithRoute {

};
interface Files {
    Key:string;
    img:any;
    Title:string;
  }
const SubFormWidget: React.FC<PcrWidgetProps> = (props: any) => {
    const classes = useStyles();
    const history = useHistory();
    const dispatch = useDispatch();
    const { handleSubmit, watch, errors, control, formState, setValue, getValues, setError } = useFormContext();
    const pcrType = watch("pcr_type");
    const [Indexdb, setIndexdb] = useState("");
    const pcr = useSelector(pcrstate)
    const [AdditionalRisksIdb,SetAdditionalRisksIdb] = useState<String>("");
    const [CanAmbulateIndependentlyIdb,SetCanAmbulateIndependentlyIdb] = useState<String>("");
    const [HandoverReceivedtime,SetHandoverReceivedtimeIdb] = useState<String>("");
    const [ConcernedWithPatientIdb,SetConcernedWithPatientIdb] = useState<String>("");
    const [ExistingSkinWoundIdb,SetExistingSkinWoundIdb] = useState<String>("");
    const [HasDietaryReactionsIdb,SetHasDietaryReactionsIdb] = useState<String>("");
    const [HasMedicationSuppliedIdb,SetHasMedicationSuppliedIdb] = useState<String>("");
    const [ListMedicationsIdb,setListMedicationsIdb] = useState<String>("");
    const [HasSignsofCovidIdb,SetHasSignsofCovidIdb] = useState<String>("");
    const [HeartRateOutsideFlagsIdb,SetHeartRateOutsideFlagsIdb] = useState<String>("");
    const [IVSitesShowInfectionIdb,SetIVSitesShowInfectionIdb] = useState<String>("");
    const [IsFallsRiskIdb,SetIsFallsRiskIdb] = useState<String>("");
    const [KnownCognitiveImpairmentIdb,SetKnownCognitiveImpairmentIdb] = useState<String>("");
    const [MustTransportedViaStretcherIdb,SetMustTransportedViaStretcherIdb] = useState<String>("");
    const [O2SaturationOutsideFlagsIdb,SetO2SaturationOutsideFlagsIdb] = useState<String>("");
    const [PatientAgitatedIdb,SetPatientAgitatedIdb] = useState<String>("");
    const [PatientCannotStatePlaceIdb,SetPatientCannotStatePlaceIdb] = useState<String>("");
    const [PatientPainScoreIdb,SetPatientPainScoreIdb] = useState<String>("");
    const [PatientPositiveTroponinIdb,SetPatientPositiveTroponinIdb] = useState<String>("");
    const [PhysicalExamfindingIdb,SetPhysicalExamfindingIdb] = useState<String>("");
    const [PotassiumLevelBelowIdb,SetPotassiumLevelBelowIdb] = useState<String>("");
    const [PreviouslyDiagnosedwithCovidIdb,SetPreviouslyDiagnosedwithCovidIdb] = useState<String>("");
    const [RequiresAidesorAmbulateIdb,SetRequiresAidesorAmbulateIdb] = useState<String>("");
    const [RequiresAirbornePrecautionsIdb,SetRequiresAirbornePrecautionsIdb] = useState<String>("");
    const [RequiresOxygen4lIdb,SetRequiresOxygen4lIdb] = useState<String>("");
    const [RespiratoryRateOutsideFlagsIdb,SetRespiratoryRateOutsideFlagsIdb] = useState<String>("");
    const [SevereAcuteMedicalIllnessIdb,SetSevereAcuteMedicalIllnessIdb] = useState<String>("");
    const [SystolicBPOutsideFlagsIdb,SetSystolicBPOutsideFlagsIdb] = useState<String>("");
    const [TreatmentLimitingOrderPhotoIdb,SetTreatmentLimitingOrderPhotoIdb] = useState<String>("");
    const [treatmentlimitingorderIdb,SettreatmentlimitingorderIdb] = useState<String>("");
    const [img, setimg] = useState(false);
    const formData = new FormData();
    const [visibileProgress, setvisibileProgress] = React.useState(false);
    const [file, setfile] = useState();
    const [fileTaruma, setfileTaruma] = useState();
    const [show, setshow] = useState(true);
    const [showTaruma, setshowTaruma] = useState(true);
    const[Keys,setKeys]=useState(0);
    const [Attachement,setAttachement] = React.useState<Files[]>([]);
    const [disabled, setdisabled] = useState(false);
    const [fileErrorMsg, setFileErrorMsg] = React.useState("");

    React.useEffect(() => {
        let db: any = null;
        db = localStorage.getItem("PatientDB");
        setIndexdb(db);
        getindexdbvalues();
        getindexdbvaluesAttachement();
    }, [])
    React.useEffect (() => {   
        if(pcr.DeleteTreatmentLimitingOrderPhoto)
        {
            setshow(false)
            setdisabled(false);
        }
    }, [pcr.DeleteTreatmentLimitingOrderPhoto])
    React.useEffect (() => {
        if(pcr.DeleteTraumachartPhoto)
        {
            getindexdbvaluesAttachement();
        }
     }, [pcr.DeleteTraumachartPhoto])
     React.useEffect(() => {      
        if(pcr.ShowImg)
        {
            getindexdbvaluesAttachement();
            getindexdbvaluesAttachementTreatment();
        }
    }, [pcr.ShowImg])
    const validateImage =async (value:any) => {
        let db = localStorage.getItem("PatientDB");
        if(db!=null && db !="")
        {
        const indexedDb = new IndexedDb(db);
        await indexedDb.createObjectStore(indexedDb.patientcarerecord);
        let Attachement = await indexedDb.getAllValue('AssessmentPlan');
        let acceptedFormats = ["image/jpeg", "image/jpg", "image/png", "image/gif", "image/heic"];
        for(let i=0;i<Attachement.length;i++)
        {  
            if(Attachement[i].Key == "traumachartPhoto")
            {    
            if(!acceptedFormats.includes(Attachement[i].value.type))
            {
                return 'Only JPEG and PNG images are allowed for Attachments.';     
            }
           }
        }
       }     
        return true;
      };
    const [selectedDate, setSelectedDate] = useState(new Date());
    const handleDateChange = (date:any) => {
        //console.log(date);
        setSelectedDate(date);
      };

const handleAssessmentPlanindexdbsave = async (Key: any, value: any): Promise<void> => {
    if (Indexdb != null || Indexdb != "") {
        const indexedDb = new IndexedDb(Indexdb);
        await indexedDb.createObjectStore(indexedDb.patientcarerecord);
        await indexedDb.deleteValue('AssessmentPlan', Key);
        await indexedDb.putValue('AssessmentPlan', { column: value, Patid: 0 }, Key);
    }
    if(Key == "treatmentlimitingorder" && value == 0)
    {    
        setshow(false); 
        dispatch(setpcrstate({name:"ShowImg",value:false}))
        const indexedDb = new IndexedDb(Indexdb);
        await indexedDb.createObjectStore(indexedDb.patientcarerecord);
        await indexedDb.deleteValue('AssessmentPlan', 'TreatmentLimitingOrderPhoto');          
        dispatch(setpcrstate({name:"ShowImg",value:true}))
        setdisabled(false);
    }
}
const getindexdbvaluesAttachement = async (): Promise<void> => {
    // 
            let db:any = null;
            let img:any=[];
            db = localStorage.getItem("PatientDB");
            if(db!=null && db !="")
            {
            const indexedDb = new IndexedDb(db);
            await indexedDb.createObjectStore(indexedDb.patientcarerecord);
            let val = await indexedDb.getAllValue('Attachement');          
            setshowTaruma(false)       
            for(let i=0;i<val.length;i++)
            {                             
                if (val[i].Key.includes("TraumachartPhoto")) {                
                  let res = val[i].value.img;
                   setKeys(i);
                   img.push({
                    Key :val[i].Key,
                    img:res
                })           
                }
                setAttachement(img);                 
            }
            if(img.length >0)
            {
                setshowTaruma(true) 
            }
              
            }
  }
  const getindexdbvaluesAttachementTreatment = async (): Promise<void> => {
    // 
            let db:any = null;
            let img:any=[];
            db = localStorage.getItem("PatientDB");
            if(db!=null && db !="")
            {
            const indexedDb = new IndexedDb(db);
            await indexedDb.createObjectStore(indexedDb.patientcarerecord);
            let val = await indexedDb.getAllValue('AssessmentPlan');          
            setshowTaruma(false)             
            for(let i=0;i<val.length;i++)
            {                             
                if (val[i].Key == "TreatmentLimitingOrderPhoto") {

                    SetTreatmentLimitingOrderPhotoIdb(val[i].value.column);
                    setfile(val[i].value.img)
                    setshow(true)
                    setdisabled(true);
                    //setValue("surname",val[i].value.column);
                }                           
            }
           
            }
  }
const handleindexdbImagesave = async (Key:any,file:any): Promise<void> => {
    dispatch(setpcrstate({name:"ShowImg",value:false}))
    const reader = new FileReader();
    let uint8 = new Uint8Array(await file.arrayBuffer());
    const blob = new Blob([uint8], { type: "image/jpeg" });
    const imageUrl = URL.createObjectURL(blob);
    const indexedDb = new IndexedDb(Indexdb);
    const base64 = await indexedDb.convertToBase64(file);
    //const buffer = Buffer.from(base64.toString().substring(base64.indexOf(',') + 1));

    let updatedFileName = generateRandomGuid() +"_" + file.name;
    const updatedFile = new File([file], updatedFileName, {
        type: file.type,
      });
    if(Indexdb!=null || Indexdb !="")
    {       
    await indexedDb.createObjectStore(indexedDb.patientcarerecord);
    let val = await indexedDb.getAllValue('Attachement');
    var res =null;
    let rows = 0;
    let itemval:any=[];
    for(let i=0;i<val.length;i++)
    {                             
        if (val[i].Key.includes("TraumachartPhoto")) {
            res = val[i].Key;   
            var keyval = res.split("TraumachartPhoto")[1]; 
            itemval.push(Number(keyval));
        }   
    }  
    if(itemval.length >0)
    {
        rows = (Math.max(...itemval) + 1);
    }                     
    //await indexedDb.deleteValue('Attachement', Key);
    await indexedDb.putValue('Attachement', { column:uint8,type:file.type,file:updatedFileName,imageurl:imageUrl,imagesize:uint8.byteLength,Base64:base64,Patid:0,img:updatedFile,Title:"Trauma Chart"},"TraumachartPhoto"+rows);
    }
    formData.append('file', updatedFile);
    dispatch(setpcrstate({name:"ShowImg",value:true}));
    //getindexdbvaluesAttachement();
  }

const generateRandomGuid  = () => {
    const newGuid = uuidv4();
    return newGuid;
  };
  const saveFiletoBlobStorage = async (): Promise<void> => {
    try {
        setvisibileProgress(true)
        const res = await api.pushFileToBlobStorage("",formData);
        if(res?.error)
        {
            alert("Error Occurs while Uploading")
        }
        setvisibileProgress(false)
        formData.delete('file');
    } catch(error) {
        setvisibileProgress(false)
    }
  };
  const saveFile = async (Key:any,e:any) => {           
    let values = getValues();      
    dispatch(setpcrstate({name:"ShowImg",value:false}))
    const file = e.target.files[0];
    const reader = new FileReader();
    let uint8 = new Uint8Array(await file.arrayBuffer());
    const blob = new Blob([uint8], { type: "image/jpeg" });
    const imageUrl = URL.createObjectURL(blob);
    //const buffer = Buffer.from(base64.toString().substring(base64.indexOf(',') + 1));
    const indexedDb = new IndexedDb(Indexdb);
    const base64 = await indexedDb.convertToBase64(file);
    //const buffer = Buffer.from(base64.toString().substring(base64.indexOf(',') + 1));
    let updatedFileName = generateRandomGuid() +"_" + file.name;
        const updatedFile = new File([file], updatedFileName, {
            type: file.type,
          });

    if(Indexdb!=null || Indexdb !="")
    {       
    await indexedDb.createObjectStore(indexedDb.patientcarerecord);
    await indexedDb.deleteValue('AssessmentPlan', Key);
    await indexedDb.putValue('AssessmentPlan', { column:uint8,type:file.type,file:updatedFileName,imageurl:imageUrl,imagesize:uint8.byteLength,Base64:base64,Patid:0,img:updatedFile,Title:"Treatment Limiting Order / ACD / NFR"  },Key);
    }
    
    formData.append('file', updatedFile);
    await saveFiletoBlobStorage();
    dispatch(setpcrstate({name:"ShowImg",value:true}))
    if(Key == "TreatmentLimitingOrderPhoto")
    {
        setfile(file);
        setshow(true);
        setdisabled(true);
    }
    if(Key == "traumachartPhoto")
    {
        setfileTaruma(file);
        setshowTaruma(true)
    }
  };
const handleFileChange = (Key: any, event: any) => {
    const file = event.target.files[0];
    setFileErrorMsg("");
    let acceptedFormats = ["image/jpeg", "image/jpg", "image/png", "image/gif", "image/heic"];
    if(file)
    {
        if(file.type && acceptedFormats.includes(file.type))
        {
            saveFile(Key, event);
        }
        else
        {
            setFileErrorMsg("Invalid file format!");
            setTimeout(() => {
                setFileErrorMsg("");
            }, 8000);
        }
        // Reset the file input value to an empty string
        event.target.value = '';
    }
};
const handleFileChangeTarumachart = async (Key: any, event: any) => {
    const files = event.target.files;
    setFileErrorMsg("");
    let acceptedFormats = ["image/jpeg", "image/jpg", "image/png", "image/gif", "image/heic"];
    for(let i=0; i<files.length; i++)
    {
        let file = files[i];
        if(file)
        {
            if(file.type && acceptedFormats.includes(file.type))
            {
                await handleindexdbImagesave(Key, file)
                await saveFiletoBlobStorage();
            }
            else
            {
                setFileErrorMsg("Invalid file format!");
                setTimeout(() => {
                    setFileErrorMsg("");
                }, 8000);
                break;
            }
        }
   }
    getindexdbvaluesAttachement()
    event.target.value = '';
};
const getindexdbvalues = async (): Promise<void> => {
    // 
            let db:any = null;
            db = localStorage.getItem("PatientDB");
            if(db!=null && db !="")
            {
            const indexedDb = new IndexedDb(db);
            await indexedDb.createObjectStore(indexedDb.patientcarerecord);
            let val = await indexedDb.getAllValue('AssessmentPlan');
            for(let i=0;i<val.length;i++)
            {
                if (val[i].Key == "AdditionalRisks")
                {
                    SetAdditionalRisksIdb(val[i].value.column);
                    //setValue("additional_risks",val[i].value.column);
                }
                if(val[i].Key == "CanAmbulateIndependently")
                {
                    SetCanAmbulateIndependentlyIdb(val[i].value.column);
                    //setValue("can_ambulate_independently",val[i].value.column);

                    //setValue("patient_identified",val[i].value.column);
                }
                if (val[i].Key == "ConcernedWithPatient") {

                    SetConcernedWithPatientIdb(val[i].value.column);
                    //setValue("surname",val[i].value.column);
                }
                if (val[i].Key == "ExistingSkinWound") {

                    SetExistingSkinWoundIdb(val[i].value.column);
                    //setValue("surname",val[i].value.column);
                }
                if (val[i].Key == "HasDietaryReactions") {
                    SetHasDietaryReactionsIdb(val[i].value.column);
                    //setValue("surname",val[i].value.column);
                }
    
                if (val[i].Key == "HasMedicationSupplied") {
                    SetHasMedicationSuppliedIdb(val[i].value.column);
                    //setValue("surname",val[i].value.column);
                }
                
                if (val[i].Key == "ListMedications") { 

                    setListMedicationsIdb(val[i].value.column);
                    //setValue("surname",val[i].value.column);
                }
                if (val[i].Key == "HasSignsofCovid") {
                    SetHasSignsofCovidIdb(val[i].value.column);
                    //setValue("surname",val[i].value.column);
                }
                if (val[i].Key == "HeartRateOutsideFlags") {
                    SetHeartRateOutsideFlagsIdb(val[i].value.column);
                    //setValue("surname",val[i].value.column);
                }
                if (val[i].Key == "IsFallsRisk") {
                    SetIsFallsRiskIdb(val[i].value.column);
                    //setValue("surname",val[i].value.column);
                }
                
                if (val[i].Key == "IVSitesShowInfection") {
                    SetIVSitesShowInfectionIdb(val[i].value.column);
                    //setValue("surname",val[i].value.column);
                }
                if (val[i].Key == "KnownCognitiveImpairment") {
                    SetKnownCognitiveImpairmentIdb(val[i].value.column);
                    //setValue("surname",val[i].value.column);
                }
                if (val[i].Key == "MustTransportedViaStretcher") {
                   SetMustTransportedViaStretcherIdb(val[i].value.column);
                   //setValue("surname",val[i].value.column);
                }
                if (val[i].Key == "O2SaturationOutsideFlags") {
                    SetO2SaturationOutsideFlagsIdb(val[i].value.column);
                    //setValue("surname",val[i].value.column);
                }
                if (val[i].Key == "PatientAgitated") {
                    SetPatientAgitatedIdb(val[i].value.column);
                    //setValue("surname",val[i].value.column);
                }
                if (val[i].Key == "PatientCannotStatePlace") {
                    SetPatientCannotStatePlaceIdb(val[i].value.column);
                    //setValue("surname",val[i].value.column);
                }
                if (val[i].Key == "PatientPainScore") {
                    SetPatientPainScoreIdb(val[i].value.column);
                    //setValue("surname",val[i].value.column);
                }
                if (val[i].Key == "PatientPositiveTroponin") {
                    SetPatientPositiveTroponinIdb(val[i].value.column);
                    //setValue("surname",val[i].value.column);
                }
                if (val[i].Key == "PhysicalExamfinding") {
                    SetPhysicalExamfindingIdb(val[i].value.column);
                    //setValue("surname",val[i].value.column);
                }
                if (val[i].Key == "PotassiumLevelBelow") {
                    SetPotassiumLevelBelowIdb(val[i].value.column);
                    //setValue("surname",val[i].value.column);
                }
                if (val[i].Key == "PreviouslyDiagnosedwithCovid") {
                    SetPreviouslyDiagnosedwithCovidIdb(val[i].value.column);
                    //setValue("surname",val[i].value.column);
                }
                if (val[i].Key == "RequiresAidesorAmbulate") {
                    SetRequiresAidesorAmbulateIdb(val[i].value.column);
                    //setValue("surname",val[i].value.column);
                }
                if (val[i].Key == "RequiresAirbornePrecautions") {
                    SetRequiresAirbornePrecautionsIdb(val[i].value.column);
                    //setValue("surname",val[i].value.column);
                }
                if (val[i].Key == "RequiresOxygen4l") {
                    SetRequiresOxygen4lIdb(val[i].value.column);
                    //setValue("surname",val[i].value.column);
                }
                if (val[i].Key == "RespiratoryRateOutsideFlags") {
                    SetRespiratoryRateOutsideFlagsIdb(val[i].value.column);
                    //setValue("surname",val[i].value.column);
                }
                if (val[i].Key == "SevereAcuteMedicalIllness") {
                    SetSevereAcuteMedicalIllnessIdb(val[i].value.column);
                    //setValue("surname",val[i].value.column);
                }
                if (val[i].Key == "SystolicBPOutsideFlags") {
                    
                    SetSystolicBPOutsideFlagsIdb(val[i].value.column);
                    //setValue("surname",val[i].value.column);
                }
                if (val[i].Key == "TreatmentLimitingOrderPhoto") {

                    SetTreatmentLimitingOrderPhotoIdb(val[i].value.column);
                    setfile(val[i].value.img)
                    setshow(true)
                    setdisabled(true);
                    //setValue("surname",val[i].value.column);
                }
                if (val[i].Key == "traumachartPhoto") {

                    //SetTreatmentLimitingOrderPhotoIdb(val[i].value.column);
                    setfileTaruma(val[i].value.img)
                    setshowTaruma(true)
                    //setValue("surname",val[i].value.column);
                }
                if (val[i].Key == "treatmentlimitingorder") {
                    SettreatmentlimitingorderIdb(val[i].value.column);
                    //setValue("surname",val[i].value.column);
                }
                
            }
            }
        }
const getGridListCols = (): number => {
    if(isWidthUp('xl', props.width))
    {
        return 5.5;
    }
    if(isWidthUp('lg', props.width))
    {
        return 4.5;
    }
    if(isWidthUp('md', props.width))
    {
        return 3.5;
    }
    if(isWidthUp('sm', props.width))
    {
        return 2.5;
    }
    return 1.5;
    }
    return (
        <div>
            <div className={classes.pcrAddTabHeading}>
                <div>
                    Assessment & Plan
                </div>
            </div>
            <Grid container className={classes.formContainer} spacing={3}>
                
                {(pcrType === "2" || pcrType === "3") && (<>
                <Grid item xs={12} sm={12}>
                    <Grid container className={classes.assessmentSwitches} spacing={0}>
                        <Grid item xs={12} sm={12} md={6} className="leftside">
                            <div className={classes.assessmentSwitchItem}>
                                <Controller
                                    control={control}
                                    name="treatment_limiting_order"
                                    defaultValue={treatmentlimitingorderIdb}
                                    render={({ onChange, onBlur, value, name }) => (
                                        <>
                                            <Grid container className={classes.buttonSwitchField} spacing={0}>
                                                <Grid item xs={8} sm={8}>
                                                    <div className={""}>
                                                        { pcr.ValidateAllFields && <Icons.RequiredIcon />}Treatment limiting order/ACD/NFR
                                                    </div>
                                                </Grid>
                                                <Grid item xs={"auto"} sm={"auto"}>
                                                    <button
                                                        type="button"
                                                        className={value === 1 ? "selected" : ""}
                                                        onClick={(e: any) => { onChange(1, handleAssessmentPlanindexdbsave('treatmentlimitingorder', 1)) }}
                                                        onBlur={(e) => {
                                                            handleAssessmentPlanindexdbsave('treatmentlimitingorder', 1);
                                                            
                                                        }}
                                                    >
                                                        Yes
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className={value === 0 ? "selected" : ""}
                                                        onClick={(e: any) => { onChange(0,handleAssessmentPlanindexdbsave('treatmentlimitingorder', 0)) }}
                                                        onBlur={(e) => {
                                                            handleAssessmentPlanindexdbsave('treatmentlimitingorder', 0);
                                                            
                                                        }}
                                                    >
                                                        No
                                                    </button>
                                                </Grid>
                                            </Grid>
                                            <FormHelperText error={errors.treatment_limiting_order}>
                                                {errors.treatment_limiting_order ? errors.treatment_limiting_order.message : ""}
                                            </FormHelperText>
                                            
                                            {(value === 1) && (<>
                                            <Controller
                                                control={control}
                                                name="treatment_limiting_order_photo"
                                                defaultValue={TreatmentLimitingOrderPhotoIdb}
                                                render={({ onChange, onBlur, name }) => (
                                                    <>
                                                        <Button
                                                            variant="contained"
                                                            className={classes.yellowBtn} 
                                                            component="label"
                                                            startIcon={<Icons.PhotoIcon />}
                                                        >
                                                            {disabled ? "Replace Image" : "Photo Required"}
                                                            <input
                                                                name={name}
                                                                type="file"
                                                                onChange={(e) => onChange(e.target.files, handleFileChange('TreatmentLimitingOrderPhoto',e))}
                                                                accept="image/*"
                                                                //style={{ display: "none" }}
                                                                hidden
                                                            />
                                                        </Button>
                                                        {visibileProgress && (<Box style={{ width: '100%' }}>
                                                            <LinearProgress />
                                                        </Box>)}
                                                        <FormHelperText error={errors.treatment_limiting_order_photo}>
                                                            {errors.treatment_limiting_order_photo ? errors.treatment_limiting_order_photo.message : ""}
                                                        </FormHelperText>
                                                        {(!!fileErrorMsg) && <FormHelperText error={true}>{fileErrorMsg}</FormHelperText>}
                                                    </>
                                                )}
                                                rules={{
                                                    required: {value:pcr.ValidateAllFields,message:"Treatment Limiting Order Photo is required"},
                                                    // validate: (e) => {
                                                    //     if(e[0])
                                                    //     {
                                                    //         let acceptedFormats = ["image/jpeg", "image/png", "image/png", "image/gif"];
                                                    //         if(!acceptedFormats.includes(e[0].type))
                                                    //         {
                                                    //             return "Only PNG, JPEG, PNG, GIF is allowed";
                                                    //         }
                                                    //         // else if(files[0]?.size > 2 * 1000 * 1000)
                                                    //         // {
                                                    //         //     return "Max 2 MB allowed";
                                                    //         // }
                                                    //     }
                                                    // },
                                                }}
                                            />
                                              <div>
                                            {file !=null && show?
                                            <div style={{display:"grid"}}> 
                                            <a>Image Uploaded Successfully</a>
                                            <img style={{width:"172px",height:"100px",marginTop:"2px"}} src={URL.createObjectURL(file)}  alt="attach" className={"attachment"} />
                                           </div> :null}                                           
                                           </div>
                                            </>)}
                                        </>
                                        
                                    )}
                                    rules={{
                                        required: {value:pcr.ValidateAllFields,message:"Treatment Limiting Order is required"},
                                    }}
                                />                                                                          
                            </div>
                          
                            <div className={classes.assessmentSwitchItem}>
                                <Controller
                                    control={control}
                                    name="can_ambulate_independently"
                                    defaultValue={CanAmbulateIndependentlyIdb}
                                    render={({ onChange, onBlur, value, name }) => (
                                        <>
                                            <Grid container className={classes.buttonSwitchField}>
                                                <Grid item xs={8} sm={8}>
                                                    <div className={""}>
                                                    { pcr.ValidateAllFields &&<Icons.RequiredIcon />}Can ambulate independently
                                                    </div>
                                                </Grid>
                                                <Grid item xs={"auto"} sm={"auto"}>
                                                    <button
                                                        type="button"
                                                        className={value === 1 ? "selected" : ""}
                                                        onClick={(e: any) => { onChange(1,handleAssessmentPlanindexdbsave('CanAmbulateIndependently', 1)) }}
                                                        onBlur={(e) => {
                                                            handleAssessmentPlanindexdbsave('CanAmbulateIndependently', 1);
                                                            
                                                        }}
                                                    >
                                                        Yes
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className={value === 0 ? "selected" : ""}
                                                        onClick={(e: any) => { onChange(0,  handleAssessmentPlanindexdbsave('CanAmbulateIndependently', 0)) }}
                                                        onBlur={(e) => {
                                                            handleAssessmentPlanindexdbsave('CanAmbulateIndependently', 0);
                                                            
                                                        }}
                                                    >
                                                        No
                                                    </button>
                                                </Grid>
                                            </Grid>
                                            <FormHelperText error={errors.can_ambulate_independently}>
                                                {errors.can_ambulate_independently ? errors.can_ambulate_independently.message : ""}
                                            </FormHelperText>
                                        </>
                                    )}
                                    rules={{
                                        required: {value:pcr.ValidateAllFields,message:"Can Ambulate Independently is required"},
                                    }}
                                />
                            </div>
                            <div className={classes.assessmentSwitchItem}>
                                <Controller
                                    control={control}
                                    name="requires_aides_or_ambulate"
                                    defaultValue={RequiresAidesorAmbulateIdb}
                                    render={({ onChange, onBlur, value, name }) => (
                                        <>
                                            <Grid container className={classes.buttonSwitchField}>
                                                <Grid item xs={8} sm={8}>
                                                    <div className={""}>
                                                    { pcr.ValidateAllFields &&<Icons.RequiredIcon />}Requires aide/s or assistance to ambulate
                                                    </div>
                                                </Grid>
                                                <Grid item xs={"auto"} sm={"auto"}>
                                                    <button
                                                        type="button"
                                                        className={value === 1 ? "selected" : ""}
                                                        onClick={(e: any) => { onChange(1, handleAssessmentPlanindexdbsave('RequiresAidesorAmbulate', 1)) }}
                                                        onBlur={(e) => {
                                                            handleAssessmentPlanindexdbsave('RequiresAidesorAmbulate', 1);
                                                            
                                                        }}
                                                    >
                                                        Yes
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className={value === 0 ? "selected" : ""}
                                                        onClick={(e: any) => { onChange(0,handleAssessmentPlanindexdbsave('RequiresAidesorAmbulate', 0)) }}
                                                        onBlur={(e) => {
                                                            handleAssessmentPlanindexdbsave('RequiresAidesorAmbulate', 0);
                                                            
                                                        }}
                                                    >
                                                        No
                                                    </button>
                                                </Grid>
                                            </Grid>
                                            <FormHelperText error={errors.requires_aides_or_ambulate}>
                                                {errors.requires_aides_or_ambulate ? errors.requires_aides_or_ambulate.message : ""}
                                            </FormHelperText>
                                        </>
                                    )}
                                    rules={{
                                        required: {value:pcr.ValidateAllFields,message:"Requires Aides or Ambulate is required"},
                                    }}
                                />
                            </div>
                            <div className={classes.assessmentSwitchItem}>
                                <Controller
                                    control={control}
                                    name="must_transported_via_stretcher"
                                    defaultValue={MustTransportedViaStretcherIdb}
                                    render={({ onChange, onBlur, value, name }) => (
                                        <>
                                            <Grid container className={classes.buttonSwitchField}>
                                                <Grid item xs={8} sm={8}>
                                                    <div className={""}>
                                                    { pcr.ValidateAllFields &&<Icons.RequiredIcon />}Must be transported via stretcher
                                                    </div>
                                                </Grid>
                                                <Grid item xs={"auto"} sm={"auto"}>
                                                    <button
                                                        type="button"
                                                        className={value === 1 ? "selected" : ""}
                                                        onClick={(e: any) => { onChange(1, handleAssessmentPlanindexdbsave('MustTransportedViaStretcher', 1)) }}
                                                        onBlur={(e) => {
                                                            handleAssessmentPlanindexdbsave('MustTransportedViaStretcher', 1);
                                                            
                                                        }}
                                                    >
                                                        Yes
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className={value === 0 ? "selected" : ""}
                                                        onClick={(e: any) => { onChange(0,   handleAssessmentPlanindexdbsave('MustTransportedViaStretcher', 0)) }}
                                                        onBlur={(e) => {
                                                            handleAssessmentPlanindexdbsave('MustTransportedViaStretcher', 0);
                                                            
                                                        }}
                                                    >
                                                        No
                                                    </button>
                                                </Grid>
                                            </Grid>
                                            <FormHelperText error={errors.must_transported_via_stretcher}>
                                                {errors.must_transported_via_stretcher ? errors.must_transported_via_stretcher.message : ""}
                                            </FormHelperText>
                                        </>
                                    )}
                                    rules={{
                                        required: {value:pcr.ValidateAllFields,message:"Must Transported Via Stretcher is required"},
                                    }}
                                />
                            </div>
                            <div className={classes.assessmentSwitchItem}>
                                <Controller
                                    control={control}
                                    name="requires_airborne_precautions"
                                    defaultValue={RequiresAirbornePrecautionsIdb}
                                    render={({ onChange, onBlur, value, name }) => (
                                        <>
                                            <Grid container className={classes.buttonSwitchField}>
                                                <Grid item xs={8} sm={8}>
                                                    <div className={""}>
                                                    { pcr.ValidateAllFields &&<Icons.RequiredIcon />}Requires airborne precautions (including COVID-19)
                                                    </div>
                                                </Grid>
                                                <Grid item xs={"auto"} sm={"auto"}>
                                                    <button
                                                        type="button"
                                                        className={value === 1 ? "selected custom1" : ""}
                                                        onClick={(e: any) => { onChange(1 ,handleAssessmentPlanindexdbsave('RequiresAirbornePrecautions', 1)) }}
                                                        onBlur={(e) => {
                                                            handleAssessmentPlanindexdbsave('RequiresAirbornePrecautions', 1);
                                                            
                                                        }}
                                                    >
                                                        Yes
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className={value === 0 ? "selected" : ""}
                                                        onClick={(e: any) => { onChange(0,  handleAssessmentPlanindexdbsave('RequiresAirbornePrecautions', 0)) }}
                                                        onBlur={(e) => {
                                                            handleAssessmentPlanindexdbsave('RequiresAirbornePrecautions', 0);
                                                            
                                                        }}
                                                    >
                                                        No
                                                    </button>
                                                </Grid>
                                            </Grid>
                                            <FormHelperText error={errors.requires_airborne_precautions}>
                                                {errors.requires_airborne_precautions ? errors.requires_airborne_precautions.message : ""}
                                            </FormHelperText>
                                            
                                            {(value === 1) && (<>
                                            <div className={"helpText"}>
                                                <Icons.RedHelpIcon />
                                                Escalation to duty manager required
                                            </div>
                                            </>)}
                                        </>
                                    )}
                                    rules={{
                                        required: {value:pcr.ValidateAllFields,message:"Requires Airborne Precautions is required"},
                                    }}
                                />
                            </div>
                            <div className={classes.assessmentSwitchItem}>
                                <Controller
                                    control={control}
                                    name="has_signs_of_covid"
                                    defaultValue={HasSignsofCovidIdb}
                                    render={({ onChange, onBlur, value, name }) => (
                                        <>
                                            <Grid container className={classes.buttonSwitchField}>
                                                <Grid item xs={8} sm={8}>
                                                    <div className={""}>
                                                    { pcr.ValidateAllFields &&<Icons.RequiredIcon />}Has signs/symptoms of COVID or other respiratory illness
                                                    </div>
                                                </Grid>
                                                <Grid item xs={"auto"} sm={"auto"}>
                                                    <button
                                                        type="button"
                                                        className={value === 1 ? "selected custom1" : ""}
                                                        onClick={(e: any) => { onChange(1, handleAssessmentPlanindexdbsave('HasSignsofCovid', 1)) }}
                                                        onBlur={(e) => {
                                                            handleAssessmentPlanindexdbsave('HasSignsofCovid', 1);
                                                            
                                                        }}
                                                    >
                                                        Yes
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className={value === 0 ? "selected" : ""}
                                                        onClick={(e: any) => { onChange(0, handleAssessmentPlanindexdbsave('HasSignsofCovid', 0)) }}
                                                        onBlur={(e) => {
                                                            handleAssessmentPlanindexdbsave('HasSignsofCovid', 0);
                                                            
                                                        }}
                                                    >
                                                        No
                                                    </button>
                                                </Grid>
                                            </Grid>
                                            <FormHelperText error={errors.has_signs_of_covid}>
                                                {errors.has_signs_of_covid ? errors.has_signs_of_covid.message : ""}
                                            </FormHelperText>
                                            
                                            {(value === 1) && (<>
                                            <div className={"helpText"}>
                                                <Icons.RedHelpIcon />
                                                Patient to wear surgical face mask if tolerated and clinically appropriate
                                            </div>
                                            </>)}
                                        </>
                                    )}
                                    rules={{
                                        required: {value:pcr.ValidateAllFields,message:"Has signs/symptoms of COVID or other respiratory illness is required"},
                                    }}
                                />
                            </div>
                            <div className={classes.assessmentSwitchItem}>
                                <Controller
                                    control={control}
                                    name="previously_diagnosed_with_covid"
                                    defaultValue={PreviouslyDiagnosedwithCovidIdb}
                                    render={({ onChange, onBlur, value, name }) => (
                                        <>
                                            <Grid container className={classes.buttonSwitchField}>
                                                <Grid item xs={8} sm={8}>
                                                    <div className={""}>
                                                    { pcr.ValidateAllFields &&<Icons.RequiredIcon />}Previously diagnosed with COVID or awaiting results from a recent COVID test
                                                    </div>
                                                </Grid>
                                                <Grid item xs={"auto"} sm={"auto"}>
                                                    <button
                                                        type="button"
                                                        className={value === 1 ? "selected custom1" : ""}
                                                        onClick={(e: any) => { onChange(1, handleAssessmentPlanindexdbsave('PreviouslyDiagnosedwithCovid', 1)) }}
                                                        onBlur={(e) => {
                                                            handleAssessmentPlanindexdbsave('PreviouslyDiagnosedwithCovid', 1);
                                                            
                                                        }}
                                                    >
                                                        Yes
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className={value === 0 ? "selected" : ""}
                                                        onClick={(e: any) => { onChange(0,handleAssessmentPlanindexdbsave('PreviouslyDiagnosedwithCovid', 0)) }}
                                                        onBlur={(e) => {
                                                            handleAssessmentPlanindexdbsave('PreviouslyDiagnosedwithCovid', 0);
                                                            
                                                        }}
                                                    >
                                                        No
                                                    </button>
                                                </Grid>
                                            </Grid>
                                            <FormHelperText error={errors.previously_diagnosed_with_covid}>
                                                {errors.previously_diagnosed_with_covid ? errors.previously_diagnosed_with_covid.message : ""}
                                            </FormHelperText>
                                            
                                            {(value === 1) && (<>
                                            <div className={"helpText"}>
                                                <Icons.RedHelpIcon />
                                                Patient to wear surgical face mask if tolerated and clinically appropriate
                                            </div>
                                            </>)}
                                        </>
                                    )}
                                    rules={{
                                        required: {value:pcr.ValidateAllFields,message:"Previously Diagnosed with Covid is required"},
                                    }}
                                />
                            </div>
                            <div className={classes.assessmentSwitchItem}>
                                <Controller
                                    control={control}
                                    name="has_dietary_reactions"
                                    defaultValue={HasDietaryReactionsIdb}
                                    render={({ onChange, onBlur, value, name }) => (
                                        <>
                                            <Grid container className={classes.buttonSwitchField}>
                                                <Grid item xs={8} sm={8}>
                                                    <div className={""}>
                                                    { pcr.ValidateAllFields &&<Icons.RequiredIcon />}Has dietary restrictions
                                                    </div>
                                                </Grid>
                                                <Grid item xs={"auto"} sm={"auto"}>
                                                    <button
                                                        type="button"
                                                        className={value === 1 ? "selected" : ""}
                                                        onClick={(e: any) => { onChange(1, handleAssessmentPlanindexdbsave('HasDietaryReactions', 1)) }}
                                                        onBlur={(e) => {
                                                            handleAssessmentPlanindexdbsave('HasDietaryReactions', 1);
                                                            
                                                        }}
                                                    >
                                                        Yes
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className={value === 0 ? "selected" : ""}
                                                        onClick={(e: any) => { onChange(0, handleAssessmentPlanindexdbsave('HasDietaryReactions', 0)) }}
                                                        onBlur={(e) => {
                                                            handleAssessmentPlanindexdbsave('HasDietaryReactions', 0);
                                                            
                                                        }}
                                                    >
                                                        No
                                                    </button>
                                                </Grid>
                                            </Grid>
                                            <FormHelperText error={errors.has_dietary_reactions}>
                                                {errors.has_dietary_reactions ? errors.has_dietary_reactions.message : ""}
                                            </FormHelperText>
                                        </>
                                    )}
                                    rules={{
                                        required: {value:pcr.ValidateAllFields,message:"Has Dietary Reactions is required"},
                                    }}
                                />
                            </div>
                            <div className={classes.assessmentSwitchItem}>
                                <Controller
                                    control={control}
                                    name="is_falls_risk"
                                    defaultValue={IsFallsRiskIdb}
                                    render={({ onChange, onBlur, value, name }) => (
                                        <>
                                            <Grid container className={classes.buttonSwitchField}>
                                                <Grid item xs={8} sm={8}>
                                                    <div className={""}>
                                                    { pcr.ValidateAllFields &&<Icons.RequiredIcon />}Is a falls risk
                                                    </div>
                                                </Grid>
                                                <Grid item xs={"auto"} sm={"auto"}>
                                                    <button
                                                        type="button"
                                                        className={value === 1 ? "selected" : ""}
                                                        onClick={(e: any) => { onChange(1,     handleAssessmentPlanindexdbsave('IsFallsRisk', 1)) }}
                                                        onBlur={(e) => {
                                                            handleAssessmentPlanindexdbsave('IsFallsRisk', 1);
                                                            
                                                        }}
                                                    >
                                                        Yes
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className={value === 0 ? "selected" : ""}
                                                        onClick={(e: any) => { onChange(0,  handleAssessmentPlanindexdbsave('IsFallsRisk', 0)) }}
                                                        onBlur={(e) => {
                                                            handleAssessmentPlanindexdbsave('IsFallsRisk', 0);
                                                            
                                                        }}
                                                    >
                                                        No
                                                    </button>
                                                </Grid>
                                            </Grid>
                                            <FormHelperText error={errors.is_falls_risk}>
                                                {errors.is_falls_risk ? errors.is_falls_risk.message : ""}
                                            </FormHelperText>
                                        </>
                                    )}
                                    rules={{
                                        required: {value:pcr.ValidateAllFields,message:"Is a Falls Risk is required"},
                                    }}
                                />
                            </div>
                            <div className={classes.assessmentSwitchItem}>
                                <Controller
                                    control={control}
                                    name="has_medication_supplied"
                                    defaultValue={HasMedicationSuppliedIdb}
                                    render={({ onChange, onBlur, value, name }) => (
                                        <>
                                            <Grid container className={classes.buttonSwitchField}>
                                                <Grid item xs={8} sm={8}>
                                                    <div className={""}>
                                                    { pcr.ValidateAllFields &&<Icons.RequiredIcon />}Has medication supplied
                                                    </div>
                                                </Grid>
                                                <Grid item xs={"auto"} sm={"auto"}>
                                                    <button
                                                        type="button"
                                                        className={value === 1 ? "selected" : ""}
                                                        onClick={(e: any) => { onChange(1,  handleAssessmentPlanindexdbsave('HasMedicationSupplied', 1)) }}
                                                        onBlur={(e) => {
                                                            handleAssessmentPlanindexdbsave('HasMedicationSupplied', 1);
                                                            
                                                        }}
                                                    >
                                                        Yes
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className={value === 0 ? "selected" : ""}
                                                        onClick={(e: any) => { onChange(0,handleAssessmentPlanindexdbsave('HasMedicationSupplied', 0)) }}
                                                        onBlur={(e) => {
                                                            handleAssessmentPlanindexdbsave('HasMedicationSupplied', 0);
                                                            
                                                        }}
                                                    >
                                                        No
                                                    </button>
                                                </Grid>
                                            </Grid>
                                            <FormHelperText error={errors.has_medication_supplied}>
                                                {errors.has_medication_supplied ? errors.has_medication_supplied.message : ""}
                                            </FormHelperText>
                                            
                                            {(value === 1) && (<>
                                            <Controller
                                                control={control}
                                                name="list_medications"
                                                defaultValue={ListMedicationsIdb}
                                                
                                                render={props => (
                                                    <TextField
                                                    defaultValue={ListMedicationsIdb}
                                                    onBlur={(e) => {
                                                        handleAssessmentPlanindexdbsave('ListMedications', e.target.value);
                                                        
                                                    }}
                                                        variant='outlined'
                                                        InputProps={{ classes: { root: classes.multilinetextFieldInput } }}
                                                        inputProps={{ autocomplete:'disabled' }}
                                                        error={errors.list_medications} helperText={errors.list_medications ? errors.list_medications.message : ""}
                                                        placeholder="List medications..."
                                                        multiline={true}
                                                        rows={2}
                                                    />
                                                )
                                                }
                                                rules={{
                                                    //required: "This field is required",
                                                }}
                                            />
                                            </>)}
                                        </>
                                    )}
                                    rules={{
                                        required: {value:pcr.ValidateAllFields,message:"Has Medication Supplied is required"},
                                    }}
                                />
                            </div>
                            <div className={classes.assessmentSwitchItem}>
                                <Controller
                                    control={control}
                                    name="severe_acute_medical_illness"
                                    defaultValue={SevereAcuteMedicalIllnessIdb}
                                    render={({ onChange, onBlur, value, name }) => (
                                        <>
                                            <Grid container className={classes.buttonSwitchField}>
                                                <Grid item xs={8} sm={8}>
                                                    <div>
                                                    { pcr.ValidateAllFields &&<Icons.RequiredIcon />}Severe acute medical illness and/or current hip fracture
                                                    </div>
                                                </Grid>
                                                <Grid item xs={"auto"} sm={"auto"}>
                                                    <button
                                                        type="button"
                                                        className={value === 1 ? "selected" : ""}
                                                        onClick={(e: any) => { onChange(1, handleAssessmentPlanindexdbsave('SevereAcuteMedicalIllness', 1)) }}
                                                        onBlur={(e) => {
                                                            handleAssessmentPlanindexdbsave('SevereAcuteMedicalIllness', 1);
                                                            
                                                        }}
                                                    >
                                                        Yes
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className={value === 0 ? "selected" : ""}
                                                        onClick={(e: any) => { onChange(0, handleAssessmentPlanindexdbsave('SevereAcuteMedicalIllness', 0)) }}
                                                        onBlur={(e) => {
                                                            handleAssessmentPlanindexdbsave('SevereAcuteMedicalIllness', 0);
                                                            
                                                        }}
                                                    >
                                                        No
                                                    </button>
                                                </Grid>
                                            </Grid>
                                            <FormHelperText error={errors.severe_acute_medical_illness}>
                                                {errors.severe_acute_medical_illness ? errors.severe_acute_medical_illness.message : ""}
                                            </FormHelperText>
                                        </>
                                    )}
                                    rules={{
                                        required: {value:pcr.ValidateAllFields,message:"Severe acute medical illness and/or current hip fracture is required"},
                                    }}
                                />
                            </div>
                            <div className={classes.assessmentSwitchItem}>
                                <Controller
                                    control={control}
                                    name="known_cognitive_impairment"
                                    defaultValue={KnownCognitiveImpairmentIdb}
                                    render={({ onChange, onBlur, value, name }) => (
                                        <>
                                            <Grid container className={classes.buttonSwitchField}>
                                                <Grid item xs={8} sm={8}>
                                                    <div>
                                                    { pcr.ValidateAllFields &&<Icons.RequiredIcon />}Known cognitive impairment AND recent behaviour change (check with support person/s, family or carer)
                                                    </div>
                                                </Grid>
                                                <Grid item xs={"auto"} sm={"auto"}>
                                                    <button
                                                        type="button"
                                                        className={value === 1 ? "selected" : ""}
                                                        onClick={(e: any) => { onChange(1,handleAssessmentPlanindexdbsave('KnownCognitiveImpairment', 1)) }}
                                                        onBlur={(e) => {
                                                            handleAssessmentPlanindexdbsave('KnownCognitiveImpairment', 1);
                                                            
                                                        }}
                                                    >
                                                        Yes
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className={value === 0 ? "selected" : ""}
                                                        onClick={(e: any) => { onChange(0,  handleAssessmentPlanindexdbsave('KnownCognitiveImpairment', 0)) }}
                                                        onBlur={(e) => {
                                                            handleAssessmentPlanindexdbsave('KnownCognitiveImpairment', 0);
                                                            
                                                        }}
                                                    >
                                                        No
                                                    </button>
                                                </Grid>
                                            </Grid>
                                            <FormHelperText error={errors.known_cognitive_impairment}>
                                                {errors.known_cognitive_impairment ? errors.known_cognitive_impairment.message : ""}
                                            </FormHelperText>
                                        </>
                                    )}
                                    rules={{
                                        required: {value:pcr.ValidateAllFields,message:"Known cognitive impairment  is required"},
                                    }}
                                />
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} className="rightside">
                            <div className={classes.assessmentSwitchItem}>
                                <Controller
                                    control={control}
                                    name="patient_agitated"
                                    defaultValue={PatientAgitatedIdb}
                                    render={({ onChange, onBlur, value, name }) => (
                                        <>
                                            <Grid container className={classes.buttonSwitchField}>
                                                <Grid item xs={8} sm={8}>
                                                    <div>
                                                    { pcr.ValidateAllFields &&<Icons.RequiredIcon />}Patient agitated, difficult to rouse, or not alert
                                                    </div>
                                                </Grid>
                                                <Grid item xs={"auto"} sm={"auto"}>
                                                    <button
                                                        type="button"
                                                        className={value === 1 ? "selected" : ""}
                                                        onClick={(e: any) => { onChange(1, handleAssessmentPlanindexdbsave('PatientAgitated', 1)) }}
                                                        onBlur={(e) => {
                                                            handleAssessmentPlanindexdbsave('PatientAgitated', 1);
                                                            
                                                        }}
                                                    >
                                                        Yes
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className={value === 0 ? "selected" : ""}
                                                        onClick={(e: any) => { onChange(0, handleAssessmentPlanindexdbsave('PatientAgitated', 0)) }}
                                                        onBlur={(e) => {
                                                            handleAssessmentPlanindexdbsave('PatientAgitated', 0);
                                                            
                                                        }}
                                                    >
                                                        No
                                                    </button>
                                                </Grid>
                                            </Grid>
                                            <FormHelperText error={errors.patient_agitated}>
                                                {errors.patient_agitated ? errors.patient_agitated.message : ""}
                                            </FormHelperText>
                                        </>
                                    )}
                                    rules={{
                                        required: {value:pcr.ValidateAllFields,message:"Patient Agitated is required"},
                                    }}
                                />
                            </div>
                            <div className={classes.assessmentSwitchItem}>
                                <Controller
                                    control={control}
                                    name="requires_oxygen_4l"
                                    defaultValue={RequiresOxygen4lIdb}
                                    render={({ onChange, onBlur, value, name }) => (
                                        <>
                                            <Grid container className={classes.buttonSwitchField}>
                                                <Grid item xs={8} sm={8}>
                                                    <div>
                                                    { pcr.ValidateAllFields &&<Icons.RequiredIcon />}Requires oxygen &gt; 4L/min for transport
                                                    </div>
                                                </Grid>
                                                <Grid item xs={"auto"} sm={"auto"}>
                                                    <button
                                                        type="button"
                                                        className={value === 1 ? "selected" : ""}
                                                        onClick={(e: any) => { onChange(1, handleAssessmentPlanindexdbsave('RequiresOxygen4l', 1)) }}
                                                        onBlur={(e) => {
                                                            handleAssessmentPlanindexdbsave('RequiresOxygen4l', 1);
                                                            
                                                        }}
                                                    >
                                                        Yes
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className={value === 0 ? "selected" : ""}
                                                        onClick={(e: any) => { onChange(0, handleAssessmentPlanindexdbsave('RequiresOxygen4l', 0)) }}
                                                        onBlur={(e) => {
                                                            handleAssessmentPlanindexdbsave('RequiresOxygen4l', 0);
                                                            
                                                        }}
                                                    >
                                                        No
                                                    </button>
                                                </Grid>
                                            </Grid>
                                            <FormHelperText error={errors.requires_oxygen_4l}>
                                                {errors.requires_oxygen_4l ? errors.requires_oxygen_4l.message : ""}
                                            </FormHelperText>
                                        </>
                                    )}
                                    rules={{
                                        required: {value:pcr.ValidateAllFields,message:"Requires Oxygen 4L/min for transport is required"},
                                    }}
                                />
                            </div>
                            <div className={classes.assessmentSwitchItem}>
                                <Controller
                                    control={control}
                                    name="existing_skin_wound"
                                    defaultValue={ExistingSkinWoundIdb}
                                    render={({ onChange, onBlur, value, name }) => (
                                        <>
                                            <Grid container className={classes.buttonSwitchField}>
                                                <Grid item xs={8} sm={8}>
                                                    <div>
                                                    { pcr.ValidateAllFields &&<Icons.RequiredIcon />}Existing skin wound or transport &gt; 2 hours duration
                                                    </div>
                                                </Grid>
                                                <Grid item xs={"auto"} sm={"auto"}>
                                                    <button
                                                        type="button"
                                                        className={value === 1 ? "selected" : ""}
                                                        onClick={(e: any) => { onChange(1,  handleAssessmentPlanindexdbsave('ExistingSkinWound', 1)) }}
                                                        onBlur={(e) => {
                                                            handleAssessmentPlanindexdbsave('ExistingSkinWound', 1);
                                                            
                                                        }}
                                                    >
                                                        Yes
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className={value === 0 ? "selected" : ""}
                                                        onClick={(e: any) => { onChange(0, handleAssessmentPlanindexdbsave('ExistingSkinWound', 0)) }}
                                                        onBlur={(e) => {
                                                            handleAssessmentPlanindexdbsave('ExistingSkinWound', 0);
                                                            
                                                        }}
                                                    >
                                                        No
                                                    </button>
                                                </Grid>
                                            </Grid>
                                            <FormHelperText error={errors.existing_skin_wound}>
                                                {errors.existing_skin_wound ? errors.existing_skin_wound.message : ""}
                                            </FormHelperText>
                                        </>
                                    )}
                                    rules={{
                                        required: {value:pcr.ValidateAllFields,message:"Existing Skin Wound is required"},
                                    }}
                                />
                            </div>
                            <div className={classes.assessmentSwitchItem}>
                                <Controller
                                    control={control}
                                    name="concerned_with_patient"
                                    defaultValue={ConcernedWithPatientIdb}
                                    render={({ onChange, onBlur, value, name }) => (
                                        <>
                                            <Grid container className={classes.buttonSwitchField}>
                                                <Grid item xs={8} sm={8}>
                                                    <div>
                                                    { pcr.ValidateAllFields &&<Icons.RequiredIcon />}I am concerned with this patient
                                                    </div>
                                                </Grid>
                                                <Grid item xs={"auto"} sm={"auto"}>
                                                    <button
                                                        type="button"
                                                        className={value === 1 ? "selected" : ""}
                                                        onClick={(e: any) => { onChange(1,  handleAssessmentPlanindexdbsave('ConcernedWithPatient', 1)) }}
                                                        onBlur={(e) => {
                                                            handleAssessmentPlanindexdbsave('ConcernedWithPatient', 1);
                                                            
                                                        }}
                                                    >
                                                        Yes
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className={value === 0 ? "selected" : ""}
                                                        onClick={(e: any) => { onChange(0,  handleAssessmentPlanindexdbsave('ConcernedWithPatient', 0)) }}
                                                        onBlur={(e) => {
                                                            handleAssessmentPlanindexdbsave('ConcernedWithPatient', 0);
                                                            
                                                        }}
                                                    >
                                                        No
                                                    </button>
                                                </Grid>
                                            </Grid>
                                            <FormHelperText error={errors.concerned_with_patient}>
                                                {errors.concerned_with_patient ? errors.concerned_with_patient.message : ""}
                                            </FormHelperText>
                                        </>
                                    )}
                                    rules={{
                                        required: {value:pcr.ValidateAllFields,message:"Concerned With Patient is required"},
                                    }}
                                />
                            </div>
                            <div className={classes.assessmentSwitchItem}>
                                <Controller
                                    control={control}
                                    name="patient_pain_score"
                                    defaultValue={PatientPainScoreIdb}
                                    render={({ onChange, onBlur, value, name }) => (
                                        <>
                                            <Grid container className={classes.buttonSwitchField}>
                                                <Grid item xs={8} sm={8}>
                                                    <div>
                                                    { pcr.ValidateAllFields &&<Icons.RequiredIcon />}Patient's pain score &gt; 5/10
                                                    </div>
                                                </Grid>
                                                <Grid item xs={"auto"} sm={"auto"}>
                                                    <button
                                                        type="button"
                                                        className={value === 1 ? "selected" : ""}
                                                        onClick={(e: any) => { onChange(1,  handleAssessmentPlanindexdbsave('PatientPainScore', 1)) }}
                                                        onBlur={(e) => {
                                                            handleAssessmentPlanindexdbsave('PatientPainScore', 1);
                                                            
                                                        }}
                                                    >
                                                        Yes
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className={value === 0 ? "selected" : ""}
                                                        onClick={(e: any) => { onChange(0, handleAssessmentPlanindexdbsave('PatientPainScore', 0)) }}
                                                        onBlur={(e) => {
                                                            handleAssessmentPlanindexdbsave('PatientPainScore', 0);
                                                            
                                                        }}
                                                    >
                                                        No
                                                    </button>
                                                </Grid>
                                            </Grid>
                                            <FormHelperText error={errors.patient_pain_score}>
                                                {errors.patient_pain_score ? errors.patient_pain_score.message : ""}
                                            </FormHelperText>
                                        </>
                                    )}
                                    rules={{
                                        required: {value:pcr.ValidateAllFields,message:"Patient Pain Score is required"},
                                    }}
                                />
                            </div>
                            <div className={classes.assessmentSwitchItem}>
                                <Controller
                                    control={control}
                                    name="heart_rate_outside_flags"
                                    defaultValue={HeartRateOutsideFlagsIdb}
                                    render={({ onChange, onBlur, value, name }) => (
                                        <>
                                            <Grid container className={classes.buttonSwitchField}>
                                                <Grid item xs={8} sm={8}>
                                                    <div>
                                                    { pcr.ValidateAllFields &&<Icons.RequiredIcon />}Heart rate outside the flags
                                                    </div>
                                                </Grid>
                                                <Grid item xs={"auto"} sm={"auto"}>
                                                    <button
                                                        type="button"
                                                        className={value === 1 ? "selected" : ""}
                                                        onClick={(e: any) => { onChange(1,   handleAssessmentPlanindexdbsave('HeartRateOutsideFlags', 1)) }}
                                                        onBlur={(e) => {
                                                            handleAssessmentPlanindexdbsave('HeartRateOutsideFlags', 1);
                                                            
                                                        }}
                                                    >
                                                        Yes
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className={value === 0 ? "selected" : ""}
                                                        onClick={(e: any) => { onChange(0,  handleAssessmentPlanindexdbsave('HeartRateOutsideFlags', 0)) }}
                                                        onBlur={(e) => {
                                                            handleAssessmentPlanindexdbsave('HeartRateOutsideFlags', 0);
                                                            
                                                        }}
                                                    >
                                                        No
                                                    </button>
                                                </Grid>
                                            </Grid>
                                            <FormHelperText error={errors.heart_rate_outside_flags}>
                                                {errors.heart_rate_outside_flags ? errors.heart_rate_outside_flags.message : ""}
                                            </FormHelperText>
                                        </>
                                    )}
                                    rules={{
                                        required: {value:pcr.ValidateAllFields,message:"Heart Rate Outside Flags is required"},
                                    }}
                                />
                            </div>
                            <div className={classes.assessmentSwitchItem}>
                                <Controller
                                    control={control}
                                    name="systolic_bp_outside_flags"
                                    defaultValue={SystolicBPOutsideFlagsIdb}
                                    render={({ onChange, onBlur, value, name }) => (
                                        <>
                                            <Grid container className={classes.buttonSwitchField}>
                                                <Grid item xs={8} sm={8}>
                                                    <div>
                                                    { pcr.ValidateAllFields &&<Icons.RequiredIcon />}Systolic BP outside the flags
                                                    </div>
                                                </Grid>
                                                <Grid item xs={"auto"} sm={"auto"}>
                                                    <button
                                                        type="button"
                                                        className={value === 1 ? "selected" : ""}
                                                        onClick={(e: any) => { onChange(1,  handleAssessmentPlanindexdbsave('SystolicBPOutsideFlags', 1)) }}
                                                        onBlur={(e) => {
                                                            handleAssessmentPlanindexdbsave('SystolicBPOutsideFlags', 1);
                                                            
                                                        }}
                                                    >
                                                        Yes
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className={value === 0 ? "selected" : ""}
                                                        onClick={(e: any) => { onChange(0,   handleAssessmentPlanindexdbsave('SystolicBPOutsideFlags', 0)) }}
                                                        onBlur={(e) => {
                                                            handleAssessmentPlanindexdbsave('SystolicBPOutsideFlags', 0);
                                                            
                                                        }}
                                                    >
                                                        No
                                                    </button>
                                                </Grid>
                                            </Grid>
                                            <FormHelperText error={errors.systolic_bp_outside_flags}>
                                                {errors.systolic_bp_outside_flags ? errors.systolic_bp_outside_flags.message : ""}
                                            </FormHelperText>
                                        </>
                                    )}
                                    rules={{
                                        required: {value:pcr.ValidateAllFields,message:"Systolic BP Outside Flags is required"},
                                    }}
                                />
                            </div>
                            <div className={classes.assessmentSwitchItem}>
                                <Controller
                                    control={control}
                                    name="respiratory_rate_outside_flags"
                                    defaultValue={RespiratoryRateOutsideFlagsIdb}
                                    render={({ onChange, onBlur, value, name }) => (
                                        <>
                                            <Grid container className={classes.buttonSwitchField}>
                                                <Grid item xs={8} sm={8}>
                                                    <div>
                                                    { pcr.ValidateAllFields &&<Icons.RequiredIcon />}Respiratory rate outside the flags
                                                    </div>
                                                </Grid>
                                                <Grid item xs={"auto"} sm={"auto"}>
                                                    <button
                                                        type="button"
                                                        className={value === 1 ? "selected" : ""}
                                                        onClick={(e: any) => { onChange(1, handleAssessmentPlanindexdbsave('RespiratoryRateOutsideFlags', 1)) }}
                                                        onBlur={(e) => {
                                                            handleAssessmentPlanindexdbsave('RespiratoryRateOutsideFlags', 1);
                                                            
                                                        }}
                                                    >
                                                        Yes
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className={value === 0 ? "selected" : ""}
                                                        onClick={(e: any) => { onChange(0,  handleAssessmentPlanindexdbsave('RespiratoryRateOutsideFlags', 0)) }}
                                                        onBlur={(e) => {
                                                            handleAssessmentPlanindexdbsave('RespiratoryRateOutsideFlags', 0);
                                                            
                                                        }}
                                                    >
                                                        No
                                                    </button>
                                                </Grid>
                                            </Grid>
                                            <FormHelperText error={errors.respiratory_rate_outside_flags}>
                                                {errors.respiratory_rate_outside_flags ? errors.respiratory_rate_outside_flags.message : ""}
                                            </FormHelperText>
                                        </>
                                    )}
                                    rules={{
                                        required: {value:pcr.ValidateAllFields,message:"Respiratory Rate Outside Flags is required"},
                                    }}
                                />
                            </div>
                            <div className={classes.assessmentSwitchItem}>
                                <Controller
                                    control={control}
                                    name="o2_saturation_outside_flags"
                                    defaultValue={O2SaturationOutsideFlagsIdb}
                                    render={({ onChange, onBlur, value, name }) => (
                                        <>
                                            <Grid container className={classes.buttonSwitchField}>
                                                <Grid item xs={8} sm={8}>
                                                    <div>
                                                    { pcr.ValidateAllFields &&<Icons.RequiredIcon />}O2 saturation outside the flags
                                                    </div>
                                                </Grid>
                                                <Grid item xs={"auto"} sm={"auto"}>
                                                    <button
                                                        type="button"
                                                        className={value === 1 ? "selected" : ""}
                                                        onClick={(e: any) => { onChange(1,handleAssessmentPlanindexdbsave('O2SaturationOutsideFlags', 1)) }}
                                                        onBlur={(e) => {
                                                            handleAssessmentPlanindexdbsave('O2SaturationOutsideFlags', 1);
                                                            
                                                        }}
                                                    >
                                                        Yes
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className={value === 0 ? "selected" : ""}
                                                        onClick={(e: any) => { onChange(0,  handleAssessmentPlanindexdbsave('O2SaturationOutsideFlags', 0)) }}
                                                        onBlur={(e) => {
                                                            handleAssessmentPlanindexdbsave('O2SaturationOutsideFlags', 0);
                                                            
                                                        }}
                                                    >
                                                        No
                                                    </button>
                                                </Grid>
                                            </Grid>
                                            <FormHelperText error={errors.o2_saturation_outside_flags}>
                                                {errors.o2_saturation_outside_flags ? errors.o2_saturation_outside_flags.message : ""}
                                            </FormHelperText>
                                        </>
                                    )}
                                    rules={{
                                        required: {value:pcr.ValidateAllFields,message:"O2 Saturation Outside Flags is required"},
                                    }}
                                />
                            </div>
                            <div className={classes.assessmentSwitchItem}>
                                <Controller
                                    control={control}
                                    name="patient_cannot_state_place"
                                    defaultValue={PatientCannotStatePlaceIdb}
                                    render={({ onChange, onBlur, value, name }) => (
                                        <>
                                            <Grid container className={classes.buttonSwitchField}>
                                                <Grid item xs={8} sm={8}>
                                                    <div>
                                                    { pcr.ValidateAllFields &&<Icons.RequiredIcon />}Patient cannot state place, name, year, DOB AND has declined from normal cognitive status if normally unable to do so
                                                    </div>
                                                </Grid>
                                                <Grid item xs={"auto"} sm={"auto"}>
                                                    <button
                                                        type="button"
                                                        className={value === 1 ? "selected" : ""}
                                                        onClick={(e: any) => { onChange(1,  handleAssessmentPlanindexdbsave('PatientCannotStatePlace', 1)) }}
                                                        onBlur={(e) => {
                                                            handleAssessmentPlanindexdbsave('PatientCannotStatePlace', 1);
                                                            
                                                        }}
                                                    >
                                                        Yes
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className={value === 0 ? "selected" : ""}
                                                        onClick={(e: any) => { onChange(0,   handleAssessmentPlanindexdbsave('PatientCannotStatePlace', 0)) }}
                                                        onBlur={(e) => {
                                                            handleAssessmentPlanindexdbsave('PatientCannotStatePlace', 0);
                                                            
                                                        }}
                                                    >
                                                        No
                                                    </button>
                                                </Grid>
                                            </Grid>
                                            <FormHelperText error={errors.patient_cannot_state_place}>
                                                {errors.patient_cannot_state_place ? errors.patient_cannot_state_place.message : ""}
                                            </FormHelperText>
                                        </>
                                    )}
                                    rules={{
                                        required: {value:pcr.ValidateAllFields,message:"Patient Cannot State Place is required"},
                                    }}
                                />
                            </div>
                            <div className={classes.assessmentSwitchItem}>
                                <Controller
                                    control={control}
                                    name="iv_sites_show_infection"
                                    defaultValue={IVSitesShowInfectionIdb}
                                    render={({ onChange, onBlur, value, name }) => (
                                        <>
                                            <Grid container className={classes.buttonSwitchField}>
                                                <Grid item xs={8} sm={8}>
                                                    <div>
                                                    { pcr.ValidateAllFields &&<Icons.RequiredIcon />}IV sites show signs of infection OR not removed (if being discharged into community)
                                                    </div>
                                                </Grid>
                                                <Grid item xs={"auto"} sm={"auto"}>
                                                    <button
                                                        type="button"
                                                        className={value === 1 ? "selected" : ""}
                                                        onClick={(e: any) => { onChange(1,   handleAssessmentPlanindexdbsave('IVSitesShowInfection', 1)) }}
                                                        onBlur={(e) => {
                                                            handleAssessmentPlanindexdbsave('IVSitesShowInfection', 1);
                                                            
                                                        }}
                                                    >
                                                        Yes
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className={value === 0 ? "selected" : ""}
                                                        onClick={(e: any) => { onChange(0,  handleAssessmentPlanindexdbsave('IVSitesShowInfection', 0)) }}
                                                        onBlur={(e) => {
                                                            handleAssessmentPlanindexdbsave('IVSitesShowInfection', 0);
                                                            
                                                        }}
                                                    >
                                                        No
                                                    </button>
                                                </Grid>
                                            </Grid>
                                            <FormHelperText error={errors.iv_sites_show_infection}>
                                                {errors.iv_sites_show_infection ? errors.iv_sites_show_infection.message : ""}
                                            </FormHelperText>
                                        </>
                                    )}
                                    rules={{
                                        required: {value:pcr.ValidateAllFields,message:"IV Sites Show Infection is required"},
                                    }}
                                />
                            </div>
                            <div className={classes.assessmentSwitchItem}>
                                <Controller
                                    control={control}
                                    name="potassium_level_below"
                                    defaultValue={PotassiumLevelBelowIdb}
                                    render={({ onChange, onBlur, value, name }) => (
                                        <>
                                            <Grid container className={classes.buttonSwitchField}>
                                                <Grid item xs={8} sm={8}>
                                                    <div>
                                                    { pcr.ValidateAllFields &&<Icons.RequiredIcon />}Potassium (K) level below 3.5 mmol/L or above 5.0 mmol/L (if avilable)
                                                    </div>
                                                </Grid>
                                                <Grid item xs={"auto"} sm={"auto"}>
                                                    <button
                                                        type="button"
                                                        className={value === 1 ? "selected" : ""}
                                                        onClick={(e: any) => { onChange(1,   handleAssessmentPlanindexdbsave('PotassiumLevelBelow', 1)) }}
                                                        onBlur={(e) => {
                                                            handleAssessmentPlanindexdbsave('PotassiumLevelBelow', 1);
                                                            
                                                        }}
                                                    >
                                                        Yes
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className={value === 0 ? "selected" : ""}
                                                        onClick={(e: any) => { onChange(0, handleAssessmentPlanindexdbsave('PotassiumLevelBelow', 0)) }}
                                                        onBlur={(e) => {
                                                            handleAssessmentPlanindexdbsave('PotassiumLevelBelow', 0);
                                                            
                                                        }}
                                                    >
                                                        No
                                                    </button>
                                                </Grid>
                                            </Grid>
                                            <FormHelperText error={errors.potassium_level_below}>
                                                {errors.potassium_level_below ? errors.potassium_level_below.message : ""}
                                            </FormHelperText>
                                        </>
                                    )}
                                    rules={{
                                        required: {value:pcr.ValidateAllFields,message:"Potassium Level Below is required"},
                                    }}
                                />
                            </div>
                            <div className={classes.assessmentSwitchItem}>
                                <Controller
                                    control={control}
                                    name="patient_positive_troponin"
                                    defaultValue={PatientPositiveTroponinIdb}
                                    render={({ onChange, onBlur, value, name }) => (
                                        <>
                                            <Grid container className={classes.buttonSwitchField}>
                                                <Grid item xs={8} sm={8}>
                                                    <div>
                                                    { pcr.ValidateAllFields &&<Icons.RequiredIcon />}Patient has a positive Troponin level
                                                    </div>
                                                </Grid>
                                                <Grid item xs={"auto"} sm={"auto"}>
                                                    <button
                                                        type="button"
                                                        className={value === 1 ? "selected" : ""}
                                                        onClick={(e: any) => { onChange(1, handleAssessmentPlanindexdbsave('PatientPositiveTroponin', 1)) }}
                                                        onBlur={(e) => {
                                                            handleAssessmentPlanindexdbsave('PatientPositiveTroponin', 1);
                                                            
                                                        }}
                                                    >
                                                        Yes
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className={value === 0 ? "selected" : ""}
                                                        onClick={(e: any) => { onChange(0,  handleAssessmentPlanindexdbsave('PatientPositiveTroponin', 0)) }}
                                                        onBlur={(e) => {
                                                            handleAssessmentPlanindexdbsave('PatientPositiveTroponin', 0);
                                                            
                                                        }}
                                                    >
                                                        No
                                                    </button>
                                                </Grid>
                                            </Grid>
                                            <FormHelperText error={errors.patient_positive_troponin}>
                                                {errors.patient_positive_troponin ? errors.patient_positive_troponin.message : ""}
                                            </FormHelperText>
                                        </>
                                    )}
                                    rules={{
                                        required: {value:pcr.ValidateAllFields,message:"Patient Positive Troponin is required"},
                                    }}
                                />
                            </div>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} sm={12}>
                    <div style={{ borderBottom: '2px solid #F1F1F1', margin: '24px 0px 0px 0px' }}></div>
                </Grid>
                <Grid item xs={12} sm={12}>
                    <div className={classes.formControlLabel}>
                        ADDITIONAL RISKS
                    </div>
                    <Controller
                        control={control}
                        name="additional_risks"
                        defaultValue={AdditionalRisksIdb}
                        render={props => (
                            <TextField
                            defaultValue={AdditionalRisksIdb}
                            onBlur={(e) => {
                                handleAssessmentPlanindexdbsave('AdditionalRisks', e.target.value);
                                
                            }}
                                variant='outlined'
                                InputProps={{ classes: { root: classes.multilinetextFieldInput } }}
                                inputProps={{ maxLength: 500, minLength: 0,autocomplete:'disabled' }}
                                error={errors.additional_risks} helperText={errors.additional_risks ? errors.additional_risks.message : ""}
                                placeholder=""
                                multiline={true}
                                rows={4}
                            />
                        )
                        }
                    />
                </Grid>
                </>)}
                
                {(pcrType === "1" || pcrType === "3") && (<>
                <Grid item xs={12} sm={12}>
                    <div className={classes.formControlLabel}>
                        PRIMARY SURVEY / SECONDARY SURVEY / PHYSICAL EXAMINATION FINDINGS
                        {pcrType === "3" && (<>
                        <span className={"incident"}>
                            <Icons.IncidentIcon /> INCIDENT
                        </span>
                        </>)}
                    </div>
                    <Controller
                        control={control}
                        name="physical_examination_findings"
                        defaultValue={PhysicalExamfindingIdb}
                        render={props => (
                            <TextField
                            defaultValue={PhysicalExamfindingIdb}
                            onBlur={(e) => {
                                handleAssessmentPlanindexdbsave('PhysicalExamfinding', e.target.value);
                                
                            }}
                                variant='outlined'
                                InputProps={{ classes: { root: classes.multilinetextFieldInput } }}
                                inputProps={{ maxLength: 500, minLength: 0,autocomplete:'disabled' }}
                                error={errors.physical_examination_findings} helperText={errors.physical_examination_findings ? errors.physical_examination_findings.message : ""}
                                placeholder=""
                                multiline={true}
                                rows={5}
                            />
                        )
                        }
                    />
                </Grid>
                {(getValues("pcr_type") === "3" || getValues("pcr_type") === "1") &&
                <Grid item xs={12} sm={12}>
                    <div className={classes.formControlLabel}>
                        TRAUMA CHART
                        {pcrType === "3" && (<>
                        <span className={"incident"}>
                            <Icons.IncidentIcon /> INCIDENT
                        </span>
                        </>)}
                    </div>
                    <Controller
                        control={control}
                        name="trauma_chart"
                        defaultValue={TreatmentLimitingOrderPhotoIdb}
                        render={({ onChange, onBlur, value, name }) => (
                            <>
                                <Button
                                    variant="contained"
                                    className={classes.yellowBtn} 
                                    component="label"
                                    startIcon={<Icons.PhotoIcon />}
                                >
                                    Attach Photo
                                    <input
                                        name={name}
                                        type="file"
                                        multiple={true}
                                        onChange={(e) => onChange(e.target.files, handleFileChangeTarumachart('traumachartPhoto',e))}
                                        accept="image/*"
                                        //style={{ display: "none" }}
                                        hidden
                                    />
                                </Button>
                                {visibileProgress && (<Box style={{ width: '100%' }}>
                                    <LinearProgress />
                                </Box>)}
                                <FormHelperText error={errors.trauma_chart}>
                                    {errors.trauma_chart && getValues("pcr_type") === "3" ? errors.trauma_chart.message : ""}
                                </FormHelperText>
                                {(!!fileErrorMsg) && <FormHelperText error={true}>{fileErrorMsg}</FormHelperText>}
                            </>
                        )}
                        rules={{
                            // required: "Traumachart is required",
                            // validate: (e) => {
                            //     if(e[0])
                            //     {
                            //         let acceptedFormats = ["image/jpeg", "image/png", "image/png", "image/gif"];
                            //         if(!acceptedFormats.includes(e[0].type))
                            //         {
                            //             return "Only PNG, JPEG, PNG, GIF is allowed";
                            //         }
                            //         // else if(files[0]?.size > 2 * 1000 * 1000)
                            //         // {
                            //         //     return "Max 2 MB allowed";
                            //         // }
                            //     }
                            // },
                        }}
                    />
                    <Grid item xs={12} sm={12}>
                          <Box className={classes.attachmentsFormList}>
                          {showTaruma ?                           
                          <GridList spacing={15} className={"gridList"} cols={getGridListCols()}>
                              {Attachement.map((item, index) => (                                                           
                                  item.img !=null ?
                                  <img style={{width:"300px",height:"150px"}} src={URL.createObjectURL(item.img)}  alt="attach" className={"attachment"} />
                                  :null                          
                              ))}
                          </GridList>
                          :null}
                          </Box>
                      </Grid>            
                </Grid>}
                </>)}

            </Grid>
        </div>
    );
}

export default React.memo(withRouter(SubFormWidget));



